import { call, takeLatest } from "redux-saga/effects";
import axiosInstance from "../axiosInstance";
import ENV from "../config/env";

import {
  SUBSCRIPTION_LIST_REQUEST,
  SUBSCRIPTION_SAVE_REQUEST,
  SUBSCRIPTION_GET_REQUEST,
  SUBSCRIPTION_ACTIVE_DEACTIVE_REQUEST,
} from "./subscription.types";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function* subscriptionListSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.BILLING_SERVICE_URL}/listing/Subscriptions`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* subscriptionSaveSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.BILLING_SERVICE_URL}/save/Subscriptions`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* subscriptionGetSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.BILLING_SERVICE_URL}/get/Subscriptions?id=${id}`
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* subscriptionActiveDeactiveSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(axiosInstance.post, payload.endPoint);
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* subscriptionWatcherSaga() {
  yield takeLatest(SUBSCRIPTION_LIST_REQUEST, subscriptionListSaga);
  yield takeLatest(SUBSCRIPTION_SAVE_REQUEST, subscriptionSaveSaga);
  yield takeLatest(SUBSCRIPTION_GET_REQUEST, subscriptionGetSaga);
  yield takeLatest(SUBSCRIPTION_ACTIVE_DEACTIVE_REQUEST, subscriptionActiveDeactiveSaga);
}
